import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-lg">Cargando...</div>;
  }

  if (!isAuthenticated) {
    // Si no está autenticado, redirige a la página de login
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && (!user || !user.isAdmin)) {
    // Si la ruta es solo para admin y el usuario no lo es, redirige a algún otro lado (ej. calendario)
    return <Navigate to="/calendar" replace />;
  }

  return children;
}

export default ProtectedRoute;